/* global window */
import React from 'react';
import { auth, stroot } from '@birdi/js-sdk';
import { css } from '@emotion/react';
import SignOutSVG from '@birdi/icons/log-out.svg';

export const SignOutButton = () => (
  <button
    type="button"
    css={css`
      text-align: left;
      width: 100%;
      padding: 0.5rem;
      display: block;
    `}
    onClick={async () => {
      // Clear session storage to prevent stale state
      sessionStorage.clear();
      // Clear any cached plan selection
      localStorage.removeItem('selectedPlanType');
      localStorage.removeItem('cancelPlan');
      localStorage.removeItem('localOldPlan');
      // Clear authentication cookie and wait for it to complete
      // Pass false to prevent auto-reload, we'll redirect ourselves
      await auth.clearCookie(stroot('gsdzx3'), false);
      // Replace history and force reload to clear bfcache
      // This prevents back button from showing authenticated pages
      window.location.replace('/sign-in');
    }}
  >
    <SignOutSVG
      css={css`
        font-size: 1.25em;
        margin-right: 1rem;
        margin-left: 0.25em;
        vertical-align: middle;
      `}
    />
    <span
      css={(theme) => css`
        vertical-align: middle;
        color: ${theme.midnight};
        font-weight: bold;
      `}
    >
      Log Out
    </span>
  </button>
);
